import React, { useEffect, useMemo, useRef, useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { debounce } from "../../helpers/utility";
import styles from "./UiTablePage.module.css";

const UiTablePageToolbar = ({
  leading = null,
  trailing = null,
  onSearch,
  searchValue,
  placeholder = "Search",
  searchAlign = "auto",
  debounceMs = 0,
  showSearch = true,
  className,
}) => {
  const [localValue, setLocalValue] = useState(searchValue ?? "");
  const onSearchRef = useRef(onSearch);

  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  useEffect(() => {
    setLocalValue(searchValue ?? "");
  }, [searchValue]);

  const triggerSearch = useMemo(() => {
    const notify = (e) => onSearchRef.current?.(e);
    if (debounceMs > 0) {
      return debounce(notify, debounceMs);
    }
    return notify;
  }, [debounceMs]);

  const hasLeading = Boolean(leading);
  const align =
    searchAlign === "auto" ? (hasLeading ? "center" : "start") : searchAlign;

  const toolbarClass = [
    styles.toolbar,
    !showSearch && styles.toolbarNoSearch,
    showSearch &&
      (align === "start"
        ? styles.toolbarSearchStart
        : styles.toolbarSearchCenter),
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleChange = (e) => {
    const nextValue = e?.target?.value ?? "";
    setLocalValue(nextValue);
    triggerSearch(e);
  };

  return (
    <div className={toolbarClass}>
      {hasLeading ? (
        <div className={styles.toolbarLeading}>{leading}</div>
      ) : null}
      {showSearch ? (
        <div className={styles.toolbarSearch}>
          <Input
            className="ui-toolbar-search"
            size="large"
            allowClear
            prefix={<SearchOutlined className="ui-toolbar-search-icon" />}
            placeholder={placeholder}
            value={localValue}
            onChange={handleChange}
          />
        </div>
      ) : null}
      {trailing ? (
        <div className={styles.toolbarTrailing}>{trailing}</div>
      ) : showSearch && align === "center" ? (
        <div className={styles.toolbarTrailing} aria-hidden="true" />
      ) : null}
    </div>
  );
};

export default UiTablePageToolbar;
